import { Container } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useAppConfig from "../hooks/useAppConfig";
import { INITIAL_ROUTE } from "../routes/const";
import ROUTE_PATHS from "../routes/routesPath";
import styles from "../shared/constants/style";
import Navbar from "./Navbar";
import {get} from "lodash";

const Layout = () => {
  const [menu, setMenu] = useState();
  const isPathRedirected = useRef(false);
  const navigate = useNavigate();
  const pwaConfig = useAppConfig();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    const config = pwaConfig?.appConfig?.config;
    if (!config) return;

    let menu = config?.menu;
    const flipbook = get(config, 'flipbook', {});
    if (get(flipbook, 'enabled') === 'true') {
      const link = get(flipbook, 'link');
      if (link) {
        menu = { FLIPBOOK: { module: 'FLIPBOOK', name: 'Curated For You', path: '' }, ...menu };
      }
    }
    setMenu(menu);

    const initialModule = config?.initialModule;
    const isDirectLanding = searchParams.get("isDirectLanding") === "true";
    // Only the app root redirects to the configured landing module — a deep
    // link (e.g. /scheme/:schemeId) must render the page that was asked for.
    const isAppRoot = location.pathname === ROUTE_PATHS.HOME;
    if (isAppRoot && !isPathRedirected.current && !isDirectLanding && INITIAL_ROUTE[initialModule]) {
      isPathRedirected.current = true;
      navigate(INITIAL_ROUTE[initialModule]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pwaConfig]);

  return (
    <>
      <Navbar menu={menu || []} />
      <Container maxWidth={styles.APP_WIDTH} style={{ paddingInline: 0 }}>
        <Outlet />
      </Container>
    </>
  );
};

export default Layout;
